export default __webpack_public_path__ + "static/media/ORCID-Badge-v-00-AUTHENTICATE.e748c284.svg";